var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transactions-list',{ref:"transactionsList",attrs:{"data-func":_vm.getTransactions,"show-user":true}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/bets/trans-bets.vue?vue&type=template&id=88246e3a&scoped=true
// module id = UGB5
// module chunks = 0